export const checkBridge = (fuc: string) => {
  const globalWindow = window as any;

  return globalWindow?.Fusion?.[fuc];
};

export const runBridge = (fuc: string, args: any, callback: any = () => {}) => {
  const globalWindow = window as any;

  globalWindow?.Fusion?.[fuc](args, callback);
};

export const checkBridgeAndRun = (name: string): Promise<Record<string, unknown> | null> => {
  return new Promise(resolve => {
    if (checkBridge(name)) {
      runBridge(name, {}, (info: { [x: string]: string }) => {
        resolve(info);
      });
    } else {
      resolve(null);
    }
  });
};
